export const EVERY_DONATION_ACTION_SUFFIX = '--every-donation'
